<div class="toolbar">
  <mat-form-field appearance="outline" class="search">
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="searchValue" (ngModelChange)="queueFilter($event)">
    @if (searchValue) {
      <button mat-icon-button matSuffix aria-label="Clear search" (click)="clearSearch()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
  <button class="add-button" mat-raised-button color="primary" (click)="addVendorProduct()">
    <mat-icon>add</mat-icon>
    Add Vendor Product
  </button>
</div>

<table class="table" mat-table [dataSource]="tableDataSource" matSort>
  <ng-container matColumnDef="vendorName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor Name</th>
    <td class="cell" mat-cell *matCellDef="let item">{{ item.vendorName }}</td>
  </ng-container>
  <ng-container matColumnDef="vendorSlug">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor Tag</th>
    <td class="cell" mat-cell *matCellDef="let item">{{ item.vendorSlug }}</td>
  </ng-container>
  <ng-container matColumnDef="productName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Name</th>
    <td class="cell" mat-cell *matCellDef="let item">{{ item.productName }}</td>
  </ng-container>
  <ng-container matColumnDef="productSlug">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Tag</th>
    <td class="cell" mat-cell *matCellDef="let item">{{ item.productSlug }}</td>
  </ng-container>
  <ng-container matColumnDef="metadata">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Metadata</th>
    <td class="cell metadata-cell" mat-cell *matCellDef="let item">
      <span [matTooltip]="getMetadataTooltip(item)">{{ getMetadataPreview(item) }}</span>
    </td>
  </ng-container>
  <ng-container matColumnDef="stripeProductId">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Stripe Product ID</th>
    <td class="cell" mat-cell *matCellDef="let item">{{ item.stripeProductId }}</td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>Actions</th>
    <td class="cell" mat-cell *matCellDef="let item">
      <button mat-icon-button [matMenuTriggerFor]="actionsMenu" [matMenuTriggerData]="{item: item}" (click)="$event.stopPropagation()">
        <mat-icon>more_vert</mat-icon>
      </button>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
  <tr
    class="listitem clickable-row"
    mat-row
    *matRowDef="let row; columns: columnNames"
    (click)="goToProduct(row)"
  ></tr>
</table>

<mat-menu #actionsMenu="matMenu">
  <ng-template matMenuContent let-item="item">
    <button mat-menu-item (click)="$event.stopPropagation(); editVendorProduct(item)">Edit</button>
    <button mat-menu-item (click)="$event.stopPropagation(); clone($event, item)">Clone</button>
    <button mat-menu-item (click)="$event.stopPropagation(); deleteVendorProduct($event, item)">Delete</button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="$event.stopPropagation(); runFtp($event, item, 'enroll')">Run Enroll FTP</button>
    <button mat-menu-item (click)="$event.stopPropagation(); runFtp($event, item, 'payment')">Run Payment FTP</button>
    <button mat-menu-item (click)="$event.stopPropagation(); rerunCarrierIntegration($event, item)">Rerun Carrier Integration</button>
  </ng-template>
</mat-menu>
